var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeauty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29814_1914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3875 0.54375C9.20938 0.621875 9.15625 0.728125 9.15625 1C9.15625 1.13125 9.16563 1.30625 9.175 1.3875L9.19688 1.53125H12.5656C14.4844 1.53125 15.9406 1.51875 15.95 1.50313C15.9594 1.4875 15.9719 1.3125 15.975 1.11563C15.9844 0.76875 15.9813 0.753125 15.9062 0.671875C15.7375 0.490625 15.9219 0.5 12.5719 0.5C10.0594 0.503125 9.46563 0.509375 9.3875 0.54375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26562 2.45937C9.28438 2.58437 10.0938 12.1187 10.0938 12.2C10.0938 12.2437 10.3531 12.25 12.5625 12.25H15.0281L15.0438 12.1469C15.0594 12.0625 15.875 2.43125 15.875 2.36562C15.875 2.35312 14.3844 2.34375 12.5625 2.34375H9.25L9.26562 2.45937Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23438 7.67196C6.15 7.69696 4.79063 8.30009 3.21875 9.01259C0.528125 10.2345 0.353125 10.3188 0.228125 10.4532C0.0875 10.6063 0 10.8188 0 11.0063C0 11.1532 0.134375 11.522 0.225 11.6157C0.328125 11.7251 0.46875 11.7595 0.6125 11.7095C0.68125 11.6845 2.16875 11.0157 3.92188 10.2188C6.1 9.23134 7.14062 8.74696 7.20312 8.68446C7.32812 8.56259 7.325 8.39696 7.19375 8.13759C7.075 7.90321 6.88438 7.73446 6.675 7.67196C6.49062 7.61571 6.4375 7.61571 6.23438 7.67196Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89005 10.4908C5.34005 10.7377 4.87755 10.9565 4.86193 10.9721C4.81505 11.0158 7.52755 11.0096 7.65255 10.9658C7.91505 10.8752 7.84943 10.5721 7.50255 10.2752C7.36818 10.1596 7.07443 10.0315 6.9588 10.0346C6.9213 10.0346 6.44005 10.2408 5.89005 10.4908Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.12435 12.2L1.07748 12.675L1.0681 13.2969C1.05873 13.9906 1.08373 14.1531 1.25873 14.5C1.38998 14.7625 1.7556 15.1375 2.02123 15.275C2.12748 15.3312 2.32123 15.4031 2.4556 15.4375C2.68373 15.4969 2.80873 15.5 4.95248 15.5C7.09623 15.5 7.22123 15.4969 7.44935 15.4375C8.0806 15.275 8.5681 14.8219 8.77123 14.2062C8.85248 13.9562 8.85248 13.9469 8.8556 12.9656C8.85873 11.8969 8.8556 11.8687 8.68685 11.7719C8.6056 11.7219 8.36498 11.7188 5.88373 11.7188L3.17123 11.7219L2.12435 12.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1617 13.9281L10.1711 14.7344L10.2586 14.9125C10.3617 15.1219 10.5398 15.2906 10.7773 15.4031L10.9523 15.4844H12.5773H14.2023L14.3742 15.4031C14.6867 15.2562 14.9023 14.9719 14.968 14.625C14.9836 14.5344 14.9992 14.1594 14.9992 13.7937V13.125H12.5742H10.1523L10.1617 13.9281Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29814_1914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeauty);
export default __webpack_public_path__ + "static/media/beauty.7a1b466c54f2dd5b7d8b912bf4549502.svg";
export { ForwardRef as ReactComponent };